/** 首页曝光：pageId */
export const TP_ACTIVITY_HOME_PAGE_ID = 'finance_loan_activityHome';
